import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {PrescriptionModel} from '../prescription.model';
import {PrescriptionSummaryConverter} from './prescriptionSummary.converter';
import {
    ConsultationSummaryConverter
} from '../../../../../consultation/consultation/api/model/converter/consultationSummary.converter';
import {PrescriptionLineConverter} from './prescriptionLine.converter';


@Injectable({providedIn: 'root' })
    export class PrescriptionConverter extends HttpModelConverter<PrescriptionModel>{
    constructor(private prescriptionSummaryConverter: PrescriptionSummaryConverter ,
                private prescriptionLineSummaryConverter: PrescriptionLineConverter,
                private consultationSummaryConverter: ConsultationSummaryConverter) {
        super();
    }

    protected createInstance(): PrescriptionModel {
        return new PrescriptionModel();
    }

    protected enrichObject(result: PrescriptionModel, src: PrescriptionModel) {
        result.summary = this.prescriptionSummaryConverter.convert(src.summary);
        result.lines = this.prescriptionLineSummaryConverter.convertFromArray(src.lines);
        result.consultation = this.consultationSummaryConverter.convert(src.consultation);
    }
}
